// state
import axios from "axios";

const defaultState = () => ({
  categoryId: null,
  faqs: [
    {
      question: null,
      answer: null
    }
  ]
});

const state = defaultState();
// getters
const getters = {};

// actions
const actions = {
  setFaq({ commit }, { id }) {
    return new Promise((resolve, reject) => {
      axios
        .get("/faqs/" + id)
        .then(response => {
          commit("SET_FAQ", response.data);
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  saveFaq({ commit, state }) {
    return new Promise((resolve, reject) => {
      axios
        .post("/faqs", state)
        .then(response => {
          commit("RESET");
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  }
};

// mutations
const mutations = {
  RESET(state) {
    Object.assign(state, defaultState());
  },
  SET_FAQ_DATA(state, data) {
    if (Object.prototype.toString.call(state[data.key]) === "[object Array]") {
      state[data.key][data.index][data.property] = data.value;
    } else if (
      Object.prototype.toString.call(state[data.key]) === "[object Object]"
    ) {
      state[data.key][data.property] = data.value;
    } else state[data.key] = data.value;
  },
  SET_FAQ(state, data) {
    state.categoryId = data.categoryId;
    state.faqs = data.faqs;
    if (state.faqs.length == 0) {
      state.faqs.push({
        question: null,
        answer: null
      });
    }
  },
  ADD_FAQ(state) {
    state.faqs.push({
      question: null,
      answer: null
    });
  },
  UPDATE_FAQ(state, { field, value, index }) {
    Object.assign(state.faqs[index], { [field]: value });
  },
  DELETE_FAQ(state, data) {
    state.faqs.splice(state.faqs.indexOf(data), 1);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
